import { render, staticRenderFns } from "./DentalAppointmentTable.vue?vue&type=template&id=42455e3f&"
import script from "./DentalAppointmentTable.vue?vue&type=script&lang=js&"
export * from "./DentalAppointmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports